const VariableCount = ({ count }) => {
  if (count < 1) {
    return null;
  }

  return (
    <span className="count">
      <span>{count}</span>
    </span>
  );
};

export default VariableCount;
